import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { TaskAssignmentApi, TaskAssignmentDTO } from './TaskAssignmentApi';
import { FaArrowLeft, FaSave } from 'react-icons/fa';

type FormMode = 'create' | 'edit';

export const TaskAssignmentForm = ({ mode }: { mode: FormMode }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState<TaskAssignmentDTO>({
    id: '',
    tenantId: '',
    tenantName: '',
    generalTaskId: '',
    projectTaskId: '',
    userId: '',
    userName: '',
    status: '',
    role: '',
    assignedBy: '',
    assignedAt: '',
    isActive: true,
    isDeleted: false,
    createdBy: '',
    updatedBy: '',
    createdAt: '',
    updatedAt: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const fetchData = async () => {
    if (mode === 'edit' && id) {
      const response = await TaskAssignmentApi.getById(id);
      setForm(response as TaskAssignmentDTO);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      if (mode === 'create') {
        await TaskAssignmentApi.create(form);
      } else {
        await TaskAssignmentApi.update(form.id!, form);
      }
      navigate('/task-assignments');
    } catch (error) {
      console.error('Error saving task assignment:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-6 mt-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-2xl font-semibold">
          {mode === 'create' ? 'Create Task Assignment' : 'Edit Task Assignment'}
        </h2>
        <div className="flex gap-2">
          <button
            onClick={() => navigate(-1)}
            className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded inline-flex items-center"
          >
            <FaArrowLeft className="mr-2" />
            Back
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
        <input type="hidden" name="id" value={form.id || ''} />

        <div>
          <label className="block mb-1 font-medium">Tenant ID</label>
          <input
            type="text"
            name="tenantId"
            value={form.tenantId || ''}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Tenant Name</label>
          <input
            type="text"
            name="tenantName"
            value={form.tenantName || ''}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">General Task ID</label>
          <input
            type="text"
            name="generalTaskId"
            value={form.generalTaskId || ''}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Project Task ID</label>
          <input
            type="text"
            name="projectTaskId"
            value={form.projectTaskId || ''}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">User ID</label>
          <input
            type="text"
            name="userId"
            value={form.userId || ''}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">User Name</label>
          <input
            type="text"
            name="userName"
            value={form.userName || ''}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Role</label>
          <input
            type="text"
            name="role"
            value={form.role || ''}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Status</label>
          <select
            name="status"
            value={form.status || ''}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          >
            <option value="">Select</option>
            <option value="ASSIGNED">Assigned</option>
            <option value="IN_PROGRESS">In Progress</option>
            <option value="COMPLETED">Completed</option>
          </select>
        </div>

        <div>
          <label className="block mb-1 font-medium">Assigned By</label>
          <input
            type="text"
            name="assignedBy"
            value={form.assignedBy || ''}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div className="col-span-2 text-right mt-4">
          <button
            type="submit"
            className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 inline-flex items-center"
          >
            <FaSave className="mr-2" />
            {mode === 'create' ? 'Create' : 'Update'}
          </button>
        </div>
      </form>
    </div>
  );
};